import React from "react";
import __i18n from "../intl/__i18n";


export const enum ApplicationStore {
  "None" = "none",
  "Others" = "others",
  "Cafebazaar" = "cafebazaar",
  "Charkhoneh" = "charkhoneh",
  "GooglePlay" = "google_play",
  "MyKet" = "my_ket",
}

export const ApplicationStoreOptions = [{
  value: ApplicationStore.None,
  label: __i18n("Not Specified")
},{
  value: ApplicationStore.Others,
  label: __i18n("Other Stores")
}, {
  value: ApplicationStore.Cafebazaar,
  label: __i18n("Cafebazaar")
}, {
  value: ApplicationStore.Charkhoneh,
  label: __i18n("Charkhoneh")
}, {
  value: ApplicationStore.GooglePlay,
  label: __i18n("GooglePlay")
}, {
  value: ApplicationStore.MyKet,
  label: __i18n("MyKet")
}];



